import { useDispatch, useSelector } from "react-redux"
import ProjectHeader from "./ProjectHeader";
import { logout } from "../../modules/auth/userSlice";
// import { useEffect } from "react";
// import { unloadProject } from "../../modules/project/projectSlice";
import { changeField as changeLanguage } from "../../modules/language/languageSlice";


const ProjectHeaderContainer = () => {
    const dispatch = useDispatch();
    // const { user, project } = useSelector(({ user, project }) => ({
    //     user: user.user,
    //     project: project.project ? project.project : JSON.parse(localStorage.getItem('project')),
    // }));
    const user = useSelector(state => state.user.user);
    const project = useSelector(state => state.project.project)
    const language = useSelector(state => state.language.language);

    const onLogout = () => {
        dispatch(logout());
    }

    const onChangeLanguage = (e) => {
        dispatch(changeLanguage({
            key: 'language',
            value: e.target.value,
        }))
    }

    // Project Header가 언마운트될 때 스토어에서 프로젝트 정보 지우기
    // useEffect(() => {

    //     return () => {
    //         dispatch(unloadProject());
    //     };
    // }, [dispatch]);


    return (
        <ProjectHeader user={user} project={project} language={language} onChangeLanguage={onChangeLanguage} onLogout={onLogout} />
    );
};

export default ProjectHeaderContainer;